import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';


export  function clientGroupsReducer(state = {}, action) {
	switch (action.type) {
		case types.GET_CLIENT_GROUPS: {
			return action.response;
		}
		case types.CLEAR_CLIENT_GROUPS: {
			return {};
		}
		default:
			return state;
	}
}

export  function clientGroupReducer(state = {}, action) {
	switch (action.type) {
		case types.GET_CLIENT_GROUP_DETAILS: {
			return action.response;
		}
		case types.CLEAR_CLIENT_GROUP: {
			return {};
		}		
		default:
			return state;
	}
}

export  function validateAllDomainsReducer(state = {value:0}, action) {
	switch (action.type) {
		case types.INCREMENT_DOMAIN_VALIDATION_COUNTER: {
			return {value:state.value+1};
		}
		default:
			return state;
	}
}

export  function createClientGroupCounterReducer(state = 0, action) {
	switch (action.type) {
		case types.ADD_CLIENT_GROUP: {
			return state+1;
		}
		default:
			return state;
	}
}

